import Swiper, {Navigation, EffectFade} from 'swiper';
Swiper.use([ Navigation, EffectFade ]);

function setCarouselMarginLeft(carouselBlock) {
    $(window).on('load resize', function () {
        let marginLeft = parseInt($('.page-footer').find('.page-container').css('margin-left')),
            paddingLeft = parseInt($('.page-footer').find('.page-container').css('padding-left'));
        $(`.${carouselBlock}`).css('margin-left', `${String(marginLeft + paddingLeft)}px`);
    });
}

const contentSlider = new Swiper(".contentSlider", {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    navigation: {
        prevEl: '.content-slider__nav .btn-prev',
        nextEl: '.content-slider__nav .btn-next',
    },
    breakpoints: {
        428: {
            spaceBetween: 12
        },
        481: {
            spaceBetween: 25
        }
    },
    on: {
        slideChangeTransitionStart: function () {
            checkFullyVisibleSlide();
        },
    },
});

const weHelpSlider = new Swiper(".weHelpSlider", {
    slidesPerView: 'auto',
    spaceBetween: 5,
    navigation: {
        prevEl: '.we-help__nav .btn-prev',
        nextEl: '.we-help__nav .btn-next',
    },
    on: {
        slideChangeTransitionStart: function () {
            checkFullyVisibleSlide();
        },
    }
});

setTimeout(function () {
    if (document.querySelector('.contentSlider')
        || document.querySelector('.weHelpSlider')) {
        checkFullyVisibleSlide();
    }
}, 1000);

contentSlider.on('transitionEnd', function () {
    checkFullyVisibleSlide();
});

weHelpSlider.on('transitionEnd', function () {
    checkFullyVisibleSlide();
});

function checkFullyVisibleSlide() {
    const swiperContainer = document.querySelector('.swiper');
    const slides = swiperContainer.querySelectorAll('.js-slide');

    slides.forEach(function (slide) {
        let slideRect = slide.getBoundingClientRect();
        let containerRect = swiperContainer.getBoundingClientRect();

        if (
            slideRect.left >= containerRect.left &&
            slideRect.right <= containerRect.right
        ) {
            slide.classList.add('fully-visible-slide');
        } else {
            slide.classList.remove('fully-visible-slide');
        }
    });
}

setCarouselMarginLeft('contentSlider');


const swiperLogos = new Swiper(".swiperLogos", {
    slidesPerView: 2,
    spaceBetween: 25,
    breakpoints: {
        360: {
            slidesPerView: 2,
            spaceBetween: 32,
        },
        576: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 4,
        },
        992: {
            slidesPerView: 5,
            spaceBetween: 25,
        },
    },
});

const testimonialsSlider = new Swiper(".testimonialsSlider", {
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 25,
    navigation: {
        prevEl: '.testimonials__nav .btn-prev',
        nextEl: '.testimonials__nav .btn-next',
    }
});


// TEAM START

const swiperTeam = new Swiper(".swiperTeam", {
    loop: false,
    speed: 100,
    effect: 'fade',
    navigation: {
        nextEl: '.team-popup__nav .btn-next',
        prevEl: '.team-popup__nav .btn-prev',
    },
});

$('.js-team-btn').click(function H(e) {
    e.preventDefault();
    $('body').addClass('body-overflow');
    $('.js-team-popup').addClass('active');
    swiperTeam.slideTo($(this).data('id'), 0);
});

$('.js-popup-close').click(function H(e) {
    e.preventDefault();
    $('body').removeClass('body-overflow');
    $('.js-team-popup').removeClass('active');
});

// $(window).on("load resize",function(e){
//     $('.js-popup-item').each(function() {
//         // let maxHeight = $(window).height() - $(this).find('img').height();
//         // $(this).find('.js-popup-desc').css('max-height', `${maxHeight}px`);
//     });
// });
// TEAM END
